@if (!stationPositions) {
  <div class="flex flex-col grow items-center justify-center">
    <nzc-busy-indicator [busy]="loading">
      <div class="text-white bg-red-light rounded-sm p-2 text-sm">
        <div class="font-bold">Could not load navigation data!</div>
      </div>
    </nzc-busy-indicator>
  </div>
} @else {
  <modus-form-field>
    <modus-label>Jump To Chainage</modus-label>
    <input
      modus-input
      [formControl]="formGroup.controls.chainage"
      (keydown.enter)="updateChainage($event)"
      class="text-right"
    />
    <div modus-text-suffix>m</div>
  </modus-form-field>
}
